import { render, staticRenderFns } from "./SavingsCalculator.vue?vue&type=template&id=27d05b90&"
import script from "./SavingsCalculator.vue?vue&type=script&lang=js&"
export * from "./SavingsCalculator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/gadzoom/gadzoom-marketing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27d05b90')) {
      api.createRecord('27d05b90', component.options)
    } else {
      api.reload('27d05b90', component.options)
    }
    module.hot.accept("./SavingsCalculator.vue?vue&type=template&id=27d05b90&", function () {
      api.rerender('27d05b90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/savings/SavingsCalculator.vue"
export default component.exports